import script from "./BikeSetup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BikeSetup.vue?vue&type=script&setup=true&lang=ts"

import "./BikeSetup.vue?vue&type=style&index=0&id=dba01828&lang=scss"

const __exports__ = script;

export default __exports__